/**
 * @description Timeout values for overriding player default values
 */
export enum PlayerLoadingTimeout {
	/**
	 * @description The number of milliseconds before a network request is considered timed out.
	 * @see {@link https://avia.vtg.paramount.tech/avia-js/latest/docs/api/player/interface/PlayerOptionsInterface#networkTimeout}
	 * @type {PlayerLoadingTimeout.NETWORK}
	 */
	NETWORK = 15000,
	/**
	 * @description default value 4 seconds / 4000 ms
	 * @type {PlayerLoadingTimeout.VAST}
	 */
	VAST = 8000,
	/**
	 * @description Applies to IMA ads only; the timeout used by the GAM IMA SDK to load ad video, in milliseconds. Default 4000
	 * @see {@link https://avia.vtg.paramount.tech/avia-js/latest/docs/api/gam/interface/GamCsaiInterface#loadVideoTimeoutMs}
	 * @type {PlayerLoadingTimeout.AD}
	 */
	AD = 8000
}